import { matchRoutes } from 'react-router-dom';

import { routes } from '.';

export const getPathParams = (keys: string[]) => {
  const results = matchRoutes(routes, window.location.pathname);
  const params: Record<string, string | undefined> = {};
  if (!results || results.length === 0) {
    //Todo: add a logger here poining route not added to routes/index.ts
    return params;
  }
  keys.forEach(key => {
    params[key] = results[0].params[key];
  });
  return params;
};

export const isChildPath = () => {
  const results = matchRoutes(routes, window.location.pathname);
  return Boolean(results && results.length > 1);
};
